import { CircularProgress } from "@material-ui/core";
import * as React from "react";
import "./LoadingSpinner.scss";

const LoadingSpinner = () => (
  <div className="LoadingSpinner">
    <CircularProgress
      size={90}
      className="LoadingSpinner__spinner"
      thickness={3}
    />
    <div className="LoadingSpinner__text">Loading...</div>
  </div>
);

export default LoadingSpinner;



// WEBPACK FOOTER //
// ./src/shared/LoadingSpinner.tsx